// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"SidebarDashboard_sidebar__36CNQ","wrapper":"SidebarDashboard_wrapper__352wK","title":"SidebarDashboard_title__1fX_w","messages":"SidebarDashboard_messages__1ZD0U"};